import React from 'react';
import '../App.css';
import WelComeLayer from '../components/WelcomeLayer'
import 'bootstrap/dist/css/bootstrap.min.css';
import InscriptionForm from "../components/InscriptionForm";
import CiberAlerts, {GLOBALS, MESSAGES} from "../util/Messages";
import {ColorSchemeQuery} from "../apollo/queries/ColorSchemeQuery";
import {Query} from "react-apollo";
import Spinner from "react-bootstrap/Spinner";
import {LightenDarkenColor} from "lighten-darken-color";
import Footer from "../components/Footer";
import ThemeToggleSwitch from '../components/ThemeToggle';
import { getInstitutionIdFromToken, isTokenValid } from '../util/JwtUtils';

export default class InscriptionApp extends React.Component {

  setInstitution(institution) {
    sessionStorage.setItem("institution", JSON.stringify(institution));
  }

  render() {
    const institutionId = this.getInstitutionId();
    
    if (!institutionId) {
      return (
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="card">
                <div className="card-body text-center">
                  <h3>Error de Configuración</h3>
                  <p>No se encontró el token JWT en la URL.</p>
                  <p>La URL debe incluir el parámetro: <code>?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...</code></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <>
        <Query query={ColorSchemeQuery} fetchPolicy={"cache-first"}
               variables={{institutionId: institutionId}}
               onError={(error) => {
                 console.log(error)
               }}
        >
          {({loading, error, data}) => {
            if (loading) {
              return (
                <div className="container mt-5">
                  <div className="row justify-content-center">
                    <div className="col-md-6 text-center">
                      <Spinner animation="border" role="status" style={{ marginRight: '0.5rem' }}>
                        <span style={{ display: 'none' }}>Cargando...</span>
                      </Spinner>
                      <span>Cargando configuración...</span>
                    </div>
                  </div>
                </div>
              );
            } else if (error) {
              return <><WelComeLayer logo={this.getLogo()} message={MESSAGES.WELCOME_MESSAGE}
                                     background={GLOBALS.defaultColor}/>
                <div className="card card-signin my-5 col-sm-6 border-left-0">
                  <div className="card-body">
                    <h1 className="card-title text-center">Inscripción a Cibercolegios</h1>
                    <CiberAlerts error="CIB-GEN-0027"/>
                  </div>
                </div>
              </>
            } else {
              console.log(data);
              this.setInstitution(data);
              return <>
                <div style={{ position: 'relative' }}>
                  <WelComeLayer 
                    logo={this.getLogo()} 
                    message={MESSAGES.WELCOME_MESSAGE}
                    background={data.colorScheme ? data.colorScheme.menuColor : GLOBALS.defaultColor}
                    mail={data.colorScheme ? data.colorScheme.adminEmail : GLOBALS.defaultEmail}
                    institutionName={data.colorScheme ? data.colorScheme.institutionName : 'Institución'}
                  />
                  {data.colorScheme ? (
                    <div style={{ position: 'absolute', top: 32, right: 32, zIndex: 2000 }}>
                      <ThemeToggleSwitch background={data.colorScheme.menuColor} />
                    </div>
                  ) : null}
                </div>
                {data.colorScheme ?
                  <style type="text/css">
                    {`
                    html {
                      font-family: ${data.colorScheme.fontFamily} !important;
                    }
                    body {
                      font-family: ${data.colorScheme.fontFamily} !important;
                    }
                    .institution-font{
                      color: ${data.colorScheme.fontColorSupMenu} !important;
                    }
                     .btn-primary {
                        background-color: ${LightenDarkenColor(data.colorScheme.menuColor, 50)};
                        color: ${data.colorScheme.fontColorSupMenu} !important;
                        border-color: ${LightenDarkenColor(data.colorScheme.menuColor, 50)} !important;
                    }
                    .btn-primary, .btn-primary:hover, .btn-primary:active, .btn-primary:visited {
                        background-color: ${data.colorScheme.menuColor} !important;
                        color: ${data.colorScheme.fontColorSupMenu} !important;
                        border-color: ${data.colorScheme.menuColor} !important;
                    }
                    
                  `}
                  </style> : null}
                <InscriptionForm background={data.colorScheme ? data.colorScheme.menuColor : GLOBALS.defaultColor} />
                <Footer footer={GLOBALS.footerImage}/>
              </>
            }

          }}

        </Query>
      </>
    );
  }


  getLogo() {
    const institutionId = this.getInstitutionId();
    const publicUrl = process.env.PUBLIC_URL || '';
    if (publicUrl.indexOf('migracionappsprod') >= 0 || publicUrl.indexOf('appsprod') >= 0) {
      return `https://www.cibercolegios.com/pls/ciber/barras_menu.ver_logo?p_id_institucion=${institutionId}`
    } else {
      return `https://pruebas.cibercolegios.com/pls/ciber/barras_menu.ver_logo?p_id_institucion=${institutionId}`
    }
  }

  getInstitutionId() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    
    // Intentar obtener el token JWT de la URL
    const token = urlParams.get('token');
    
    if (!token) {
      console.error('No se encontró token JWT en la URL');
      return null;
    }
    
    // Verificar si el token es válido
    if (!isTokenValid(token)) {
      console.error('Token JWT inválido o expirado');
      return null;
    }
    
    // Extraer el ID de la institución del token
    const institutionId = getInstitutionIdFromToken(token);
    
    if (!institutionId) {
      console.error('No se pudo extraer el ID de la institución del token JWT');
      return null;
    }
    
    // Almacenar el token en sessionStorage para uso posterior
    sessionStorage.setItem('authToken', token);
    
    return institutionId;
  }

}